import {combineReducers} from 'redux';

function data(state = {}, action) {
  switch (action.type) {
    case 'FETCH_LOCALE_SUCCESS':
      return action.data;
    default:
      return state;
  }
}

export default combineReducers({
  data
});



// WEBPACK FOOTER //
// ./reducers/locale.js